import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("统计")

import { ref, Ref, reactive, onBeforeMount, computed, pushScopeId } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/confirmation/statistics': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

onBeforeMount(() => {
  MI_params.date = []
})

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: ['2021-01-01', '2023-06-30'],
    upKey: 'date',
    upProps: {startKey: 'from', endKey: 'to'},
    props: { type: 'monthrange', 'value-format': 'YYYY-MM-DD', clearable: false, },
  },
])

let statisticsTable: any = ref([])
const totalAmountObj: any = reactive({})
const searchHandle = async (params: any) => {
  if(dayjs(params.date[0]).month() !== 0){
    ElMessage.warning('请从一月份开始搜索')
    return
  }
  
  let { passAmountMap, sendAmountMap, totalAmountMap, unPassAmountMap } = await fetchData(params)
  Object.assign(totalAmountObj, totalAmountMap)

  // ---------------统计------------------
  let percentage: any = {
    label: '回函比例'
  }
  for(let key in passAmountMap){
    percentage[key] = (passAmountMap[key] + unPassAmountMap[key]).toFixed(2)
  }

  statisticsTable.value = [
    {...sendAmountMap, label: '发送比例'},
    {...passAmountMap, label: '合格比例'},
    {...unPassAmountMap, label: '不合格比例'},
    percentage,
  ]
  
}

let tableData = computed(() => {
  return MI_tableData.value.map(row => {
    // 一层循环 
    // label: 发送状态
    row.data.map((row2: any) => {
      // 二层循环 
      // 合格标志
      row2.status = row2.label
      row2.label = ''
      row2.data = row2.data.map((row3: any) => {
        // 合计
        for(let key in row3.sumData){
          row[key] = row3.sumData[key] +  (row[key] || 0)
        }
        // 团队
        return {
          team: row3.label,
          label: '',
          uuid: row3.uuid,
          ...row3.sumData
        }
      })

      return row2
    })

    return row
  })
})

// 统计动态列
const yearColumns = computed(() => {
  if(MI_params.date.length === 0){
    return []
  }
  let startYaar = parseInt(MI_params.date[0].split('-')[0])
  let endYear = parseInt(MI_params.date[1].split('-')[0])

  // 如果结束月份是12月份
  let isFullYear = dayjs(MI_params.date[1]).month() === 11
  if(isFullYear){
    endYear = endYear + 1
  }

  // 区间年份
  let yearArr = []
  let length = endYear - startYaar
  for (let index = 0; index < length; index++) {
    yearArr.push(startYaar + index + '')
  }

  // 添加非完整年
  if(!isFullYear){
    yearArr.push(dayjs(MI_params.date[1]).format('YYYY-MM'))
  }

  return yearArr
})

// -------
const formatterHandle = (row: Object, column: any, cellValue: number) => {
  if(!cellValue){
    return '-'
  }
  return getNumber(cellValue) + '%'
}

const getSummaries = () => {
  let arr = ['合计', '', '']
  for(let index in yearColumns.value){
    let yearStr = dayjs(yearColumns.value[index]).format('YYYY')
    arr.push(getNumber(totalAmountObj [yearStr + '年订单本位币金额']))
    arr.push(getNumber(totalAmountObj [yearStr + '年收款本位币金额']))
  }
  arr.push(getNumber(totalAmountObj['未收款本位币金额']))

  return arr
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
        initSearch: true,
        title: true,
        searchConfig: searchConfig.value,
      }, { onSearchFn: searchHandle }), null, 16),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      "row-key": "uuid",
      "show-summary": "",
      "summary-method": getSummaries,
      "tree-props": { children: 'data'},
      ref: "tb",
      border: "",
      data: _unref(tableData),
      "max-height": _unref(MI_height)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "发送状态",
          prop: "label",
          "show-overflow-tooltip": "",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          label: "合格标志",
          prop: "status",
          "show-overflow-tooltip": "",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "team",
          "show-overflow-tooltip": "",
          width: "90"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearColumns), (item) => {
          return (_openBlock(), _createBlock(_component_el_table_column, { label: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: item + '年订单本位币金额',
                prop: _unref(dayjs)(item).format('YYYY') + '年订单本位币金额',
                "show-overflow-tooltip": "",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["label", "prop", "formatter"]),
              _createVNode(_component_el_table_column, {
                label: item + '年收款本位币金额',
                prop: _unref(dayjs)(item).format('YYYY') + '年收款本位币金额',
                "show-overflow-tooltip": "",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["label", "prop", "formatter"])
            ]),
            _: 2
          }, 1024))
        }), 256)),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "未收款本位币金额",
          prop: "未收款本位币金额",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_divider, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(statisticsTable)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "发送类型",
          prop: "label",
          width: "100"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearColumns), (item) => {
          return (_openBlock(), _createBlock(_component_el_table_column, { label: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: item + '年订单本位币金额',
                prop: _unref(dayjs)(item).format('YYYY') + '年订单本位币金额',
                align: "right",
                formatter: formatterHandle
              }, null, 8, ["label", "prop"]),
              _createVNode(_component_el_table_column, {
                label: item + '年收款本位币金额',
                prop: _unref(dayjs)(item).format('YYYY') + '年收款本位币金额',
                align: "right",
                formatter: formatterHandle
              }, null, 8, ["label", "prop"])
            ]),
            _: 2
          }, 1024))
        }), 256)),
        _createVNode(_component_el_table_column, {
          label: "未收款本位币金额",
          prop: "未收款本位币金额",
          align: "right",
          formatter: formatterHandle
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})